// @mui
import type { FabProps, SxProps } from '@mui/material';

import { Box, Fab } from '@mui/material';
import { m } from 'framer-motion';
import { forwardRef } from 'react';

// ----------------------------------------------------------------------

export interface FabButtonAnimateProps extends FabProps {
  sxWrap?: SxProps;
}

const FabButtonAnimate = forwardRef<HTMLButtonElement, FabButtonAnimateProps>(
  ({ children, size = 'large', sx, sxWrap, ...other }, ref) => (
    <AnimateWrap size={size} sxWrap={sxWrap}>
      <Fab ref={ref} size={size} sx={sx} {...other}>
        {children}
      </Fab>
    </AnimateWrap>
  )
);

FabButtonAnimate.displayName = 'FabButtonAnimate';

export default FabButtonAnimate;

// ----------------------------------------------------------------------

type AnimateWrapProp = {
  children: React.ReactNode;
  size: 'large' | 'medium' | 'small';
  sxWrap?: SxProps;
};

const varSmall = {
  hover: { scale: 1.07 },
  tap: { scale: 0.97 },
};

const varMedium = {
  hover: { scale: 1.06 },
  tap: { scale: 0.98 },
};

const varLarge = {
  hover: { scale: 1.05 },
  tap: { scale: 0.99 },
};

const AnimateWrap = ({ children, size, sxWrap }: AnimateWrapProp) => {
  const isSmall = size === 'small';
  const isLarge = size === 'large';

  return (
    <Box
      component={m.div}
      sx={{
        display: 'inline-flex',
        ...sxWrap,
      }}
      variants={(isSmall && varSmall) || (isLarge && varLarge) || varMedium}
      whileHover="hover"
      whileTap="tap"
    >
      {children}
    </Box>
  );
};
